module.exports = __webpack_public_path__ + "img/Union-green.48e99612.svg";